import { useLanguage } from '../contexts/LanguageContext';
import translations from '../content/translations';

export const useTranslation = () => {
  const { language } = useLanguage();
  
  // Get translation for current language, fallback to English
  const t = translations[language] || translations.en;
  
  return { t, language };
};

export default useTranslation;
